import { TenantFlagsPanel } from '@features/feature-flags';
import { useParams } from 'react-router';

/**
 * This client's feature flags.
 *
 * A shell, not a screen: everything that knows what a flag *is* lives in the
 * flags feature, and this file only says which museum the panel is about. The
 * alternative — a clients-owned table reading the flags API — would put flag
 * semantics (archived is the kill switch, a verdict is not an `enabled`) in two
 * features that have to agree forever.
 *
 * ## Why it is its own tab rather than part of Product settings
 *
 * They are two altitudes of the same data, and collapsing them would hide that.
 * Product settings is what the client *bought* — owned by Product, permanent,
 * and in the end state it materialises into the very override rows listed here.
 * A flag is an engineering switch: owned by Engineering, temporary, and most of
 * them are meant to be deleted at GA. Same table, different question, different
 * person answering it.
 *
 * ## Why it does not take the target
 *
 * The other tabs are target-scoped because the clients API proxies upstream per
 * environment and refuses a request that does not say where it is aimed. Flags
 * are not proxied: they live in this deployment's own table, so the environment
 * *is* the deployment and there is nothing to put on the query string. The tab
 * href still carries `?env=&slot=` — dropping it would strand the rest of the
 * strip — it simply does not reach the flags read.
 */
export function ClientFlagsTab() {
    const { tenantId = '' } = useParams();

    return <TenantFlagsPanel tenantId={tenantId} />;
}
